module.exports = __webpack_public_path__ + "assets/img/Group_304.6a76562b.png";